import { api } from "@/lib/api/client";
import type { MemberActivityPage } from "@/lib/activity";

export interface MemberActivityParams {
  /** `YYYY-MM-DD`; omitted = all days (newest first). */
  date?: string;
  cursor?: string | null;
  /** 1–100 (backend clamps). */
  limit?: number;
}

/** The member activity feed — `core.member_api` (tenant JWT). Lives under the
 *  event stream (`/events/member/`), not `/tenant-portal/`. */
export const activityApi = {
  list: ({ date, cursor, limit }: MemberActivityParams = {}) =>
    api.get<MemberActivityPage>("/events/member/", {
      params: { date, cursor: cursor || undefined, limit },
    }),
};
